/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import UsersList from "../../Modals/usersList";

const NotificationsList = () => {

  const navigate = useNavigate();

  const usersList = [
    { id: "1", label: "John Doe", role: "Customers", avatar: "/static/images/user_placeholder.png" },
    { id: "2", label: "Jane Smith", role: "Dealers", avatar: "/static/images/user_placeholder.png" },
    { id: "3", label: "Michael Scott", role: "Customers", avatar: "/static/images/user_placeholder.png" },
    { id: "4", label: "Pam Beesly", role: "Customers", avatar: "/static/images/user_placeholder.png" },
    { id: "5", label: "Jim Halpert", role: "Dealers", avatar: "/static/images/user_placeholder.png" },
  ];

  const rows = [
    {
      id: 1,
      title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      type: "Broadcast",
      date: "01-Sept-2025",
      users: ["1", "2", "3", "4", "5"]
    },
    {
      id: 2,
      title: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      type: "Broadcast",
      date: "01-Sept-2025",
      users: ["1", "2", "3", "4", "5"]
    },
  ];

  const getAudienceLabel = (userIds: string[]) => {
    const selectedUsers = usersList.filter((u) => userIds.includes(u.id));

    const roleCount: { [key: string]: number } = {};

    selectedUsers.forEach((user) => {
      roleCount[user.role] = (roleCount[user.role] || 0) + 1;
    });

    return Object.entries(roleCount)
      .map(([role, count]) => `${role} (${count})`)
      .join(", ");
  };

  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Recipients</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.type}</TableCell>

                {/* Recipients CELL */}
                <TableCell
                  className="click_action"
                  onClick={() => {
                    setSelectedUserIds(row.users);
                    setOpenUserModal(true);
                  }}
                >
                  {getAudienceLabel(row.users)}
                </TableCell>

                <TableCell>{row.date}</TableCell>

                <TableCell>
                  <Box className="table_actions v2">
                    <IconButton onClick={() => navigate('/manage-notifications/detail')}>
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>

                    <IconButton>
                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                    </IconButton>
                  </Box>
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* USERS MODAL */}
      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default NotificationsList;